export const YANDEX_SCRIPT_SELECTOR = '#script-yandex-metrics'
